const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");

const SessionalitySetting = r => require.ensure([], () => r(require('./views/SessionalitySetting.vue')))
//const AdStockDecay = r => require.ensure([], () => r(require('./views/AdStockDecay.vue')))
const NewvariableCreation = r => require.ensure([], () => r(require('./views/NewvariableCreation.vue')))
const VariableTransformation = r => require.ensure([], () => r(require('./views/VariableTransformation.vue')))
const VariableSplit = r => require.ensure([], () => r(require('./views/VariableSplit.vue')))

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/sessionalitysetting",
      component: SessionalitySetting
    },
    /*{
      path: "/adstockdecay",
      component: AdStockDecay
    },*/
    {
      path: "/newvariablecreation",
      component: NewvariableCreation
    },
    {
      path: "/variabletransformation",
      component: VariableTransformation
    }
    ,
    {
      path: "/variablesplit",
      component: VariableSplit
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
